import FillButton from "components/Button/FillButton";
import { BUILDER_CONFIG, CMPT_CONF_BUILDER_TYPE, CMPT_CONF_DETAILS, CMPT_CONF_HASH_MODEL_NAME, CMPT_CONF_MODEL_ID, CONFIG_CUSTOMIZATION, CUSTOMIZATION_SHARE_BUILD_LABEL, DEFN_ID } from "constants/constants";
import { useAppContext } from "contexts/AppContext";
import { get, words } from "lodash";
import React, { useState, useRef, useEffect } from "react";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoShareSocialSharp } from "react-icons/io5";
import { LuCopy } from "react-icons/lu";
import AuthManager from "Services/AuthManager";
import Utils from "Services/Utils";

const URLShareComponent = () => {
    const {modelSpec, backingDataInfo, builderSpec} = useAppContext()

    const [url, setUrl] = useState("");
    const [copied, setCopied] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    const [generate, setGenerate] = useState<boolean>(false);

    useEffect(() => {
        if(!generate) {
            setUrl("")
            return
        }

        let backingUrlString = ""

        const DcConfigs = get(window, 'compatioConfig.compatibleProducts.dcConfig');
        const modelShortName = DcConfigs?.find((each) => each[CMPT_CONF_BUILDER_TYPE] === "sb3" && modelSpec?.[DEFN_ID] === each[CMPT_CONF_MODEL_ID])?.[CMPT_CONF_DETAILS][CMPT_CONF_HASH_MODEL_NAME]

        if(!modelShortName || !AuthManager.getSessionId()) return

        if(backingDataInfo) backingUrlString = Utils.objectToUrlParams(backingDataInfo)
            
        setUrl(`${window.location.protocol}//${window.location.host}/#configure&model=${modelShortName}&sessionId=${AuthManager.getSessionId()}${backingDataInfo ? ("&" + backingUrlString) : ""}`)
    }, [generate, backingDataInfo]);

    const handleCopy = () => {
        if (inputRef.current) {
            // Select the text field
            inputRef.current?.select();
            // Copy text to clipboard
            navigator.clipboard.writeText(url);

            // Show copied feedback
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    if (!generate)
        return (
            <div className="sb3-h-[74px]">
                <FillButton
                    onClick={() => setGenerate(true)}
                    className="sb3-share-build sb3-space-x-2 sb3-transition-colors !sb3-bg-[#d7d7d7] !sb3-border-[858585] !sb3-text-black sb3-justify-between !sb3-rounded-lg !sb3-p-0 sb3-overflow-hidden"
                >
                    <span className="sb3-share-build-text sb3-font-bold sb3-p-2 sb3-flex-grow">{builderSpec?.[BUILDER_CONFIG]?.[CONFIG_CUSTOMIZATION]?.[CUSTOMIZATION_SHARE_BUILD_LABEL] ?? "Share Outfit"}</span>
                    <span className="sb3-bg-[#b3b3b3] sb3-h-full sb3-aspect-square sb3-p-2 sb3-absolute sb3-right-0 sb3-top-0"><IoShareSocialSharp className="sb3-share-build-icon sb3-text-xl " /></span>
                </FillButton>
            </div>
        );

    return (
        <div className="sb3-url-share-container sb3-h-[74px] sb3-mx-auto">
            <div className="sb3-url-share-label sb3-mb-2 text-gray-700 sb3-font-medium">
                URL to Share
            </div>
            <div className="sb3-url-input-wrapper sb3-rounded sb3-flex sb3-flex-grow sb3-border sb3-border-black">
                <input
                    ref={inputRef}
                    type="text"
                    value={url}
                    readOnly
                    className={`sb3-url-input sb3-w-full sb3-p-2 sb3-pr-0 sb3-rounded focus:sb3-outline-none ${copied ? "sb3-text-gray-500" : "sb3-text-black"
                        }`}
                />
                <button
                    onClick={handleCopy}
                    className={`sb3-copy-button sb3-aspect-square sb3-p-2 ${copied
                            ? "sb3-bg-[#4E972E] sb3-text-white"
                            : "sb3-bg-black hover:sb3-bg-gray-900"
                        } sb3-rounded-r focus:sb3-outline-none`}
                    title="Copy to clipboard"
                >
                    {copied ? (
                        <IoIosCheckmarkCircleOutline className="sb3-text-white sb3-text-2xl" />
                    ) : (
                        <LuCopy className="sb3-text-white sb3-text-2xl" />
                    )}
                </button>
            </div>
        </div>
    );
};

export default URLShareComponent;
